export const stripDr = (name) => (name || '').replace(/^Dr\.?\s+/i, '');

// FastAPI returns 422 details as an array of {msg}; toasts must always get a string.
export const formatApiError = (detail) => {
  if (detail == null) return 'Something went wrong. Please try again.';
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) return detail.map((e) => (e && typeof e.msg === 'string' ? e.msg : JSON.stringify(e))).join(' ');
  if (typeof detail.msg === 'string') return detail.msg;
  if (typeof detail === 'object' && !Array.isArray(detail) && (detail.$$typeof || detail.props)) return detail;
  return String(detail);
};
